import { Pipe, PipeTransform } from '@angular/core';

import { SchoolCounselorInfo } from '../services/application/application.service';

import { TitleCasePipe } from './titlecase.pipe';

@Pipe({
    name: 'counselorName'
})
export class CounselorNamePipe implements PipeTransform {
    constructor(private titleCase : TitleCasePipe) { }

    transform(sapid : string, counselors : SchoolCounselorInfo[]) {
        if (!sapid || !counselors || !counselors.length) return '';

        let person = counselors.find(item => {return item.EmployeeSAPID == sapid;});
        if (!person) return '';

        let name = this.titleCase.transform(`${person.EmployeeLastName}, ${person.EmployeeFirstName}`);

        return name;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/counselorname.pipe.ts